import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth0 } from "../react-auth0-spa";

import { API_URL } from "../../constants/constants";

export const useDeletePaquetes = () => {
  // console.log(initialUser)
  const [body, setBody] = useState({});
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently } = useAuth0();

  useEffect(() => {
    if (Object.keys(body).length === 0) return;

    const fetchDirecciones = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const { _id } = body;
        const t = await getTokenSilently();
        const r = await axios.delete(API_URL + `/paquetes/${_id}`, {
          headers: {
            // "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${t}`
          },
          params: _id
        });
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    fetchDirecciones();
  }, [body,getTokenSilently]);

  return [{ data, isLoading, isError }, setBody];
};

export default useDeletePaquetes;
